import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PrintDoc from "./PrintDoc";
import ModalImage from "react-modal-image";

import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetClientState, getClient } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetPurchaseState, getPurchase as onGetPurchases, addNewPurchase as onAddNewPurchase, updatePurchase as onUpdatePurchase, deletePurchase as onDeletePurchase, getPurchaseLoading } from "../../../store/purchase/action";
import { resetProductInventoryState, getProductInventory as onGetProductInventories, addNewProductInventory as onAddNewProductInventory, updateProductInventory as onUpdateProductInventory, deleteProductInventory as onDeleteProductInventory, getProductInventoryLoading } from "../../../store/productInventory/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";
import ExportDoc from "../../../Components/Common/ExportDoc";
defineElement(lottie.loadAnimation);

const Purchase = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [purDocImg, setPurDocImg] = useState([]);
  const [modalMedia, setModalMedia] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, purchases, purchaseAdded, isPurchaseCreated, isPurchaseSuccess, loading, error, isProductInventoryCreated, companies, companyLoading, branches, branchLoading, productVarians, productVarianLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    purchaseAdded: state.Purchase.purchaseAdded,
    purchases: state.Purchase.purchases,
    isPurchaseCreated: state.Purchase.isPurchaseCreated,
    isPurchaseSuccess: state.Purchase.isPurchaseSuccess,
    loading: state.Purchase.loading,
    isProductInventoryCreated: state.ProductInventory.isProductInventoryCreated,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Purchase.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [purchaseList, setPurchaseList] = useState([]);
  const [purchaseDoc, setPurchaseDoc] = useState([]);
  const [purchase, setPurchase] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusPurchase, setStatusPurchase] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [originalFiles, setOriginalFiles] = useState([]);
  const [productList, setProductList] = useState([]);
  const [purchaseDetailItem, setPurchaseDetailItem] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = purDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setPurDocImg(newState);
    } else {
      const index = purDocImg.findIndex((fl) => fl.filename === file.filename);
      setPurDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setPurDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPurchases = purchases;
      if (type !== "all") {
        filteredPurchases = purchases.filter((purchase) => purchase.purchase_status.name === type);
      }
      setPurchaseList(filteredPurchases);
    }
  };

  useEffect(() => {
    if (companySelected && branchSelected) {
      dispatch(onGetPurchases({ type: "inbound-product", branchId: branchSelected?.value ?? "" }));
      handleGetBranch(companySelected.value);
      handleGetProductVariant(companySelected.value);
    }
  }, [branchSelected, companySelected]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (isProductInventoryCreated) {
      dispatch(resetProductInventoryState());
      dispatch(resetPurchaseState());
      dispatch(onGetPurchases({ type: "inbound-product", branchId: branchSelected?.value ?? "" }));
    }
  }, [dispatch, isProductInventoryCreated]);

  useEffect(() => {
    setPurchase(purchaseAdded);
  }, [purchaseAdded]);

  useEffect(() => {
    if (!isEmpty(purchaseAdded)) {
      setPurchase(purchaseAdded);
    }
  }, [purchaseAdded]);

  useEffect(() => {
    if (!isEmpty(purchases)) {
      let filteredPurchases = purchases;
      if (activeTypeTab !== "all") {
        filteredPurchases = purchases.filter((purchase) => purchase.purchase_status.name === activeTypeTab);
      }
      setPurchaseList(filteredPurchases.map((el) => ({ ...el, isChecked: false })));
      setInfo(purchases[purchases.length - 1]);
    }
    else {
      setPurchaseList([]);
      setInfo({});
    }
  }, [purchases]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "Invoice No",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_reff",
        label: "Invoice Ref",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_vendor",
        label: "Pengirim",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_branch",
        label: "Cabang Penerima",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_detail_accept",
        label: "Accept",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_detail_reject",
        label: "Reject",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_status",
        label: "Status",
        isSelected: true,
        data: [],
      },
      {
        id: "approvedat",
        label: "Tanggal disetujui",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_pm",
        label: "Metode Pembelian",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total Harga",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (purchaseList.length > 0) {
      purchaseList.forEach((purchase) => {
        if (purchase.isChecked) {
          Object.entries(purchase).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "transactionat" || doc.id === "dueat" || doc.id === "approvedat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "purchase_vendor" || doc.id === "purchase_branch" || doc.id === "purchase_company" || doc.id === "purchase_client" || doc.id === "purchase_status" || doc.id === "purchase_pm") {
                doc.data.push(value.name);
              } else if (doc.id === "total_amount") {
                doc.data.push(parseFloat(value === null ? 0 : value));
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "purchase_detail") {
                const acceptDoc = dataDoc.find((d) => d.id === "purchase_detail_accept");
                const rejectDoc = dataDoc.find((d) => d.id === "purchase_detail_reject");

                let qtyAccept = 0;
                let qtyReject = 0;
                value.forEach((element) => {
                  qtyAccept += element.accepted ? parseFloat(element.accepted) : 0;
                  qtyReject += element.rejected ? parseFloat(element.rejected) : 0;
                });
                acceptDoc.data.push(qtyAccept);
                rejectDoc.data.push(qtyReject);
              }
            }
          });
        }
      });
    }

    setPurchaseDoc(dataDoc);
  }, [purchaseList]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian_name = item.pvar_product.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });

        var obj = { label: varian_name + " " + option_name.slice(0, -1) + " - " + barcode, name: varian_name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId };
        opt.push(obj);
      });
      var option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPurchase(null);
      setPurDocImg([]);
      setOriginalFiles([]);
      setPurchaseDetailItem([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setPurchase(null);
      setPurchaseDetailItem([]);
      setOriginalFiles([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleInvoiceClick = (arg) => {
    const purchase = arg;
    let purchaseDetail = [];

    if (purchase.purchase_detail) {
      purchase.purchase_detail.forEach((element) => {
        purchaseDetail.push({
          detailId: element.id,
          item: { label: element.name, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
          amount: parseFloat(element.amount),
          quantity: parseFloat(element.quantity),
          total: parseFloat(element.amount_total),
          name: element.name,
          sku: element.sku,
          uom: element?.purchase_detail_product?.product_uom?.name,
          cvl_account: element?.purchase_cvl_account?.name,
          cvl_type: element?.purchase_cvl_budget?.type,
          barcode: element.barcode,
          brandId: element.brandId,
          accepted: element.accepted ? parseFloat(element.accepted) : 0,
          rejected: element.rejected ? parseFloat(element.rejected) : 0,
        });
      });
      setPurchaseDetailItem(purchaseDetail);
    }

    setPurchase(purchase);
    let files = [];
    for (const f of purchase.purchase_file) {
      files.push({ filename: f.filename, originalname: f.originalname });
    }
    setOriginalFiles(files);
    toggleDetail();
  };

  const handlePurchaseClick = useCallback(
    (arg) => {
      const purchase = arg;
      let purchaseDetail = [];

      if (purchase.purchase_detail) {
        purchase.purchase_detail.forEach((element) => {
          purchaseDetail.push({
            detailId: element.id,
            purchaseId: purchase.id,
            itemId: element.productVarianId,
            item: { label: element.name, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
            amount: parseFloat(element.amount),
            quantity: element.accepted ? parseFloat(element.quantity) - parseFloat(element.accepted) : parseFloat(element.quantity),
            total: parseFloat(element.amount_total),
            name: element.name,
            sku: element.sku,
            uom: element?.purchase_detail_product?.product_uom?.name,
            disable: parseFloat(element.quantity) === parseFloat(element.accepted) ? true : false,
            cvl_account: element?.purchase_cvl_account?.name,
            cvl_type: element?.purchase_cvl_budget?.type,
            barcode: element.barcode,
            brandId: element.brandId,
            accepted: element.accepted ? parseFloat(element.quantity) - parseFloat(element.accepted) : parseFloat(element.quantity),
            rejected: element.rejected ? parseFloat(element.rejected) : 0,
          });
        });
        setPurchaseDetailItem(purchaseDetail);
      }

      let files = [];
      for (const f of purchase.purchase_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setOriginalFiles(files);

      setPurchase({
        id: purchase.id,
        description: purchase.description,
        type: purchase.type && { label: purchase.type, value: purchase.type },
        branch: purchase.purchase_branch && { label: purchase.purchase_branch.name, value: purchase.purchase_branch.id },
        company: purchase.purchase_company && purchase.purchase_company.name && { label: purchase.purchase_company.name, value: purchase.purchase_company.id },
        client: purchase.purchase_client && purchase.purchase_client.name && { label: purchase.purchase_client.name, value: purchase.purchase_client.id },
        status: purchase.purchase_status && { label: purchase.purchase_status.name, value: purchase.purchase_status.id },
        clientId: purchase.clientId,
        branchId: purchase.branchId,
        companyId: purchase.companyId,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  function currencyFormat(num) {
    return "Rp " + parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = purchaseList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPurchaseList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      let qty = 0;
      let acc = 0;
      data.purchase_detail.forEach((element) => {
        qty += element.quantity ? parseFloat(element.quantity) : 0;
        acc += element.accepted ? parseFloat(element.accepted) : 0;
      });
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = purchaseList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setPurchaseList(updatedData);
            }}
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className="btn-sm"
                onClick={() => {
                  handleInvoiceClick(data);
                }}
              >
                <i className="ri-eye-line fs-15"></i>
              </Button>
              {qty > acc && (
                <Button
                  color="soft-success"
                  className={userType === "admin" || userType === "client" ? "btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("createProductInventory") !== -1 ? "btn btn-sm btn-soft-success fs-12 me-0" : "btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                  onClick={() => {
                    handlePurchaseClick(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> TERIMA BARANG
                </Button>
              )}
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        </div>
      );
    },
  },
  {
    id: "Tanggal",
    Header: "Tgl Pembelian",
    accessor: "transactionat",
    filterable: false,
    Cell: (data) => {
      return handleValidDate(data.row.original.transactionat);
    },
  },
  {
    Header: "Anggaran",
    accessor: (data) => data.purchase_detail[0]?.purchase_cvl_budget?.type,
    filterable: true,
  },
  {
    id: "Detail",
    Header: "Detail",
    accessor: (data) => JSON.stringify(data.purchase_detail),
    filterable: true,
  },
  {
    Header: "Pengirim",
    accessor: "purchase_vendor.name",
    filterable: true,
  },
  {
    Header: "Cabang Penerima",
    accessor: "purchase_branch.name",
    filterable: true,
  },
  {
    Header: "Jumlah",
    filterable: true,
    Cell: (data) => {
      let qty = 0;
      data.row.original.purchase_detail.forEach((element) => {
        qty += element.quantity ? parseFloat(element.quantity) : 0;
      });
      return <span className="fw-semibold">{parseFloat(qty)}</span>;
    },
  },
  {
    Header: "Diterima",
    filterable: true,
    Cell: (data) => {
      let qty = 0;
      data.row.original.purchase_detail.forEach((element) => {
        qty += element.accepted ? parseFloat(element.accepted) : 0;
      });
      return <span className="fw-semibold">{parseFloat(qty)}</span>;
    },
  },
  {
    id: "Ditolak",
    Header: "Ditolak",
    filterable: true,
    Cell: (data) => {
      let qty = 0;
      data.row.original.purchase_detail.forEach((element) => {
        qty += element.rejected ? parseFloat(element.rejected) : 0;
      });
      return <span className={qty > 0 ? "fw-semibold text-danger" : "fw-semibold"}>{parseFloat(qty)}</span>;
    },
  },
  {
    Header: "Status",
    accessor: "purchase_status.name",
    filterable: true,
    Cell: (cell) => {
      switch (cell.value) {
        case "DRAFT":
          return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
        case "CONFIRMED" || "PROCESSED":
          return <span className="badge text-uppercase badge-soft-secondary">CONFIRMED</span>;
        case "RECEIVED":
          return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
        case "COMPLETED":
          return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
        default:
          return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
      }
    },
  },
  ],
    [purchaseList, handlePurchaseClick, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = purchaseList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPurchaseList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => purchaseList, [purchaseList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: purchaseList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Ditolak", "Detail"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";

    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusPurchase.value ? statusPurchase.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: branchSelected?.value ?? "",
      type: "inbound-product",
    };
    dispatch(onGetPurchases(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPurchaseList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(onGetPurchases({ type: "inbound-product", branchId: branchSelected?.value ?? "" }));
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (purchase && purchase.id) || 0,
      client: (purchase && purchase.client) || clientSelected,
      company: (purchase && purchase.company) || companySelected,
      branchId: (purchase && purchase.branchId) || 0,
      description: "",
      branch: (purchase && purchase.branch) ?? "",
      item: purchaseDetailItem,
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Please enter company").nullable(true),
      client: Yup.object().required("Please enter company").nullable(true),
    }),
    onSubmit: (values) => {
      // dispatch(getPurchaseLoading());
      const addSubmit = {
        purchaseId: values.id,
        clientId: values.client.value,
        companyId: values.company.value,
        statusId: 3,
        description: values.description,
        transaction_type: "Purchase",
        transaction_status: "IN",
        branchId: values.branchId,
        inv_detail: JSON.stringify(values.item),
        files: purDocImg.length > 0 ? purDocImg : [],
      };
      dispatch(onAddNewProductInventory(addSubmit));

      validation.resetForm();
      toggle();
    },
  });

  function handlePurchaseDetailAdd() {
    let arrPurchaseDetail = [];
    purchaseDetailItem.forEach((element) => {
      arrPurchaseDetail.push(element);
    });
    arrPurchaseDetail.push({
      detailId: 0,
      itemId: null,
      item: {
        label: "Select Product",
        value: null,
        name: "Select Product",
        sku: null,
        barcode: null,
        amount: 0,
        brandId: null,
        productId: null,
      },
      amount: 0,
      quantity: 0,
      total: 0,
      uom: "",
      name: "Select Product",
      disable: false,
      sku: null,
      barcode: null,
      brandId: null,
      accepted: 0,
      rejected: 0,
    });
    setPurchaseDetailItem(arrPurchaseDetail);
  }

  const onClickDeleteDetailItem = (index) => {
    purchaseDetailItem.splice(index, 1);
  };

  document.title = "Penerimaan Barang Atas Pembelian | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={purchaseList} />
      <Container fluid>
        <BreadCrumb title="Persediaan" pageTitle="Penerimaan Barang Atas Pembelian" loading={loading}>
          <div className="flex-shrink-0">
            <ExportDoc data={purchaseDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-truck-line fs-15 me-1 align-bottom"></i> ALL INBOUND
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "PROCESSED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> PROCESSED
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={8}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              value={filterDate}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={1}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, idx) => (
                              <th key={idx} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          const detail = JSON.parse(row.values.Detail);
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                              {(detail || [])
                                .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))
                                .map((o, i) => {
                                  return (
                                    <tr key={i} className="bg-light">
                                      <td colSpan={3} className="p-2"></td>
                                      <td colSpan={2} className="text-start fs-12 p-2">
                                        {o.name} - {o.cvl_account}
                                      </td>
                                      <td className="text-left fs-12 p-2 pe-3 text-muted">
                                        {parseFloat(o.quantity)} {o.purchase_detail_product?.product_uom?.name}
                                      </td>
                                      <td colSpan={2} className="p-2"></td>
                                    </tr>
                                  );
                                })}
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Penerimaan Barang" : "Penerimaan Barang"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      setPurchaseList([]);
                    }}
                  >
                    <ModalBody>
                      <CardBody className="">
                        <Row className="g-3">
                          <Col lg={12} sm={12}>
                            <div className="mb-3">
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="fs-20 ri-barcode-box-line"></i>
                                </span>
                                <Input name="transaction_reff" id="transaction_reff" className="fs-20 form-control" placeholder="Enter Barcode" type="text" value={validation.values.transaction_reff} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={validation.touched.transaction_reff && validation.errors.transaction_reff ? true : false} />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="border-top border-top-dashed">
                        <div>
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>
                                  #
                                </th>
                                <th scope="col">Detail Produk</th>
                                <th scope="col" className="text-center">
                                  Anggaran
                                </th>
                                <th scope="col" className="text-center" style={{ width: "200px" }}>
                                  Jumlah
                                </th>
                                <th scope="col" className="text-center" style={{ width: "100px" }}>
                                  Satuan
                                </th>
                                <th scope="col" className="text-center" colSpan={2}>
                                  Jumlah Penerimaan Barang
                                </th>
                                <th scope="col" className="text-start d-none" colSpan={2}>
                                  Rejected
                                </th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {purchaseDetailItem.map((o, i) => {
                                return (
                                  <tr key={i} id={i} className="product">
                                    <th scope="row" className="product-id">
                                      {i + 1}
                                    </th>
                                    <td className="text-start vertical-align-center" style={{ minWidth: "220px" }}>
                                      <div>
                                        <Select
                                          name="item"
                                          value={purchaseDetailItem[i].item}
                                          placeholder="Select Product"
                                          isDisabled={true}
                                          onChange={(e) => {
                                            purchaseDetailItem[i].item = e;
                                            purchaseDetailItem[i].sku = e.sku;
                                            purchaseDetailItem[i].barcode = e.barcode;
                                            purchaseDetailItem[i].itemId = e.value;
                                            purchaseDetailItem[i].brandId = e.brandId;
                                            purchaseDetailItem[i].amount = parseFloat(e.price);
                                            purchaseDetailItem[i].quantity = 1;
                                            validation.setFieldValue("item", purchaseDetailItem);
                                          }}
                                          options={productList}
                                          validate={{ required: { value: true } }}
                                          invalid={validation.touched.item && validation.errors.item ? true : false}
                                        ></Select>
                                        {validation.touched.item && validation.errors.item ? (
                                          <p className="invalid-feedback d-block" type="invalid">
                                            {validation.errors.item}
                                          </p>
                                        ) : null}
                                      </div>
                                    </td>
                                    <td className="text-center vertical-align-center">
                                      <div className="mt-2">
                                        {purchaseDetailItem[i].cvl_type} - {purchaseDetailItem[i].cvl_account}
                                      </div>
                                    </td>
                                    <td className="text-center vertical-align-center">
                                      <div className="mt-2 fs-15">{purchaseDetailItem[i].quantity}</div>
                                    </td>
                                    <td className="text-center vertical-align-center">
                                      <div className="mt-2">{purchaseDetailItem[i].uom}</div>
                                    </td>
                                    <td className="text-end vertical-align-center">
                                      <div className={purchaseDetailItem[i].disable === true ? "d-none" : ""}>
                                        <div className="input-step">
                                          <button
                                            type="button"
                                            className="minus bg-soft-success"
                                            onClick={() => {
                                              purchaseDetailItem[i].accepted = purchaseDetailItem[i].accepted > 0 ? purchaseDetailItem[i].accepted - 1 : purchaseDetailItem[i].accepted;
                                              validation.setFieldValue("item", purchaseDetailItem);
                                            }}
                                          >
                                            –
                                          </button>
                                          <Input
                                            name={`purchaseDetailItem.${i}.accepted`}
                                            onFocus={(e) => e.target.select()}
                                            placeholder="Qty"
                                            type="text"
                                            className="product-accepted border-0"
                                            style={{ width: "100px" }}
                                            value={purchaseDetailItem[i].accepted}
                                            onChange={(e) => {
                                              let val = e.target.value.replace(/,/g, ".");
                                              if (!isNaN(val)) {
                                                purchaseDetailItem[i].accepted = val;
                                              } else {
                                                purchaseDetailItem[i].accepted = 0;
                                              }
                                              validation.setFieldValue("item", purchaseDetailItem);
                                            }}
                                            onBlur={validation.handleBlur}
                                          />
                                          <button
                                            type="button"
                                            className="plus bg-soft-success"
                                            onClick={() => {
                                              purchaseDetailItem[i].accepted = purchaseDetailItem[i].accepted + 1;
                                              validation.setFieldValue("item", purchaseDetailItem);
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div className={purchaseDetailItem[i].disable === true ? "d-none" : ""}>
                                        <button
                                          type="button"
                                          className="btn btn btn-soft-success"
                                          onClick={() => {
                                            purchaseDetailItem[i].accepted = purchaseDetailItem[i].quantity;
                                            validation.setFieldValue("item", purchaseDetailItem);
                                          }}
                                        >
                                          All
                                        </button>
                                      </div>
                                    </td>
                                    <td className="product-removal d-none">
                                      <div className="input-step">
                                        <button
                                          type="button"
                                          className="minus bg-soft-warning"
                                          onClick={() => {
                                            purchaseDetailItem[i].rejected = purchaseDetailItem[i].rejected > 0 ? purchaseDetailItem[i].rejected - 1 : purchaseDetailItem[i].rejected;
                                            validation.setFieldValue("item", purchaseDetailItem);
                                          }}
                                        >
                                          –
                                        </button>
                                        <Input
                                          name={`purchaseDetailItem.${i}.rejected`}
                                          onFocus={(e) => e.target.select()}
                                          placeholder="Qty"
                                          type="text"
                                          className="product-rejected border-0"
                                          style={{ width: "80px" }}
                                          value={purchaseDetailItem[i].rejected}
                                          onChange={(e) => {
                                            let val = parseFloat(e.target.value);
                                            if (!isNaN(val)) {
                                              purchaseDetailItem[i].rejected = val;
                                            } else {
                                              purchaseDetailItem[i].rejected = 0;
                                            }
                                            validation.setFieldValue("item", purchaseDetailItem);
                                          }}
                                          onBlur={validation.handleBlur}
                                        />
                                        <button
                                          type="button"
                                          className="plus bg-soft-warning"
                                          onClick={() => {
                                            purchaseDetailItem[i].rejected = purchaseDetailItem[i].rejected + 1;
                                            validation.setFieldValue("item", purchaseDetailItem);
                                          }}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </td>
                                    <td className="d-none">
                                      <button
                                        type="button"
                                        className="btn btn-soft-warning"
                                        onClick={() => {
                                          purchaseDetailItem[i].rejected = purchaseDetailItem[i].quantity;
                                          validation.setFieldValue("item", purchaseDetailItem);
                                        }}
                                      >
                                        All
                                      </button>
                                    </td>
                                    {purchaseDetailItem[i].isNewItem && (
                                      <td className="product-removal">
                                        <Link
                                          to="#"
                                          className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                          onClick={() => {
                                            onClickDeleteDetailItem(i);
                                            validation.setFieldValue("item", purchaseDetailItem);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </td>
                                    )}
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tbody>
                              <tr className="d-none">
                                <td colSpan="7">
                                  <Link
                                    to="#"
                                    className="btn btn-soft-success fw-medium"
                                    id="add-item"
                                    onClick={() => {
                                      handlePurchaseDetailAdd();
                                    }}
                                  >
                                    <i className="ri-add-fill me-1 align-bottom"></i> Material
                                  </Link>
                                </td>
                              </tr>
                              <tr className="border-top border-top-dashed mt-2">
                                <td colSpan="3">
                                  <div className="mb-3 d-flex justify-content-between">
                                    <Label htmlFor="education" className="form-label">
                                      Upload Bukti Dokumen
                                    </Label>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-label btn-soft-success"
                                      onClick={() => {
                                        toggleMedia();
                                      }}
                                    >
                                      <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                    </button>
                                  </div>
                                  {purDocImg.map((f, i) => {
                                    if (f.isDeleted) {
                                      return null;
                                    } else {
                                      return (
                                        <div key={i} className="border-bottom mb-3">
                                          <div className="d-flex justify-content-between mb-3 align-items-center">
                                            <div className="me-2">
                                              {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                                <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                              ) : (
                                                <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                  <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                                </Link>
                                              )}
                                            </div>

                                            <div className="text-truncate">{f.originalname}</div>
                                            <div>
                                              <Link
                                                to="#"
                                                className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                                onClick={(e) => {
                                                  handleDeleteFile(f);
                                                }}
                                              >
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                  <div className="mb-3">
                                    <Label htmlFor="address-field" className="form-label">
                                      Keterangan
                                    </Label>
                                    <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                                    {validation.touched.description && validation.errors.description && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.description}
                                      </small>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit ? "Update Penerimaan Barang" : "Tambah Penerimaan Barang"}
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Detail Penerimaan Barang
                  </ModalHeader>
                  {purchase !== undefined && purchase !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                                <div className="mt-sm-3 mt-3">
                                  <h6 className="text-uppercase fs-15 fw-semibold">{purchase?.purchase_client?.name}</h6>
                                  <p className="mb-1 fw-semibold">{purchase?.purchase_company?.name}</p>
                                  <p className="mb-1 fw-semibold">{purchase?.purchase_branch?.name}</p>
                                </div>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              <Col lg={12} xs={12}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Tanggal</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(purchase.transactionat)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4">
                            <div>
                              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "50px" }}>
                                      #
                                    </th>
                                    <th scope="col">Detail Produk</th>
                                    <th scope="col">Anggaran</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Satuan</th>
                                    <th scope="col">Terima</th>
                                    <th scope="col d-none">Rejected</th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {(purchaseDetailItem || []).map((o, i) => {
                                    return (
                                      <tr key={i} id={o.id} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o.name}</td>
                                        <td>
                                          {o.cvl_type} - {o.cvl_account}
                                        </td>
                                        <td>{o.quantity}</td>
                                        <td>{o.uom}</td>
                                        <td>{o.accepted}</td>
                                        <td className="d-none">{o.rejected}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                            <div className="mt-4">
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  <span className="fw-semibold">NOTES:</span>
                                  <span id="note"> {purchase.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="mt-4">
                              <div>
                                <p className="mb-0">{purchase.user}</p>
                              </div>
                            </div>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleDetail();
                        }}
                      >
                        Tutup
                      </button>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={purchase} />
      </Container>
    </div>
  );
};

export default Purchase;
